var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoltage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2813 2.25H24.0235C23.686 2.25 23.3203 2.50781 23.2266 2.83594C20.2891 9.14062 14.3438 21.9891 13.7813 23.2266C13.2188 24.4641 13.9063 24.8828 14.3203 24.9375H24.3282L18.9375 34.4297H15.3516C14.1703 34.4297 14.1719 35.211 14.3203 35.6016C15.1016 38.4375 16.7485 44.3344 17.086 45.2344C17.4235 46.1344 18.4609 45.6094 18.9375 45.2344C21.9922 42.8047 28.5141 37.6031 30.1641 36.2344C31.8141 34.8656 30.7422 34.461 30 34.4297H26.3438C28.4532 30.6094 32.9157 22.5609 33.8907 20.9297C34.8657 19.2984 33.9532 18.8594 33.375 18.8438H23.5782C25.7188 14.289 30.1407 4.90781 30.7032 3.82031C31.2657 2.73281 30.6563 2.32031 30.2813 2.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoltage);
export default __webpack_public_path__ + "static/media/voltage.fc85008528dc6c96317e4844176df825.svg";
export { ForwardRef as ReactComponent };